import { Link } from 'react-router-dom';
import useUserContext from '../../api/UserContext';
import Alert from '../../components/ui/Alert';
import routes from '../../config/routes';
import type { QuestionBankID } from '../../data/interface-question-bank';
import type { User } from '../../data/interface-user';

interface FreeTrialAlertProps {
	currentUser: User;
	examTarget: QuestionBankID | undefined;
	examTargetYear: number | undefined;
}

const FreeTrialAlert = ({
	currentUser,
	examTarget,
	examTargetYear
}: FreeTrialAlertProps) => {
	// TODO: Non enurm users have no use of the free trial
	console.log('examTarget', examTarget);
	const { endFreeTrial } = useUserContext();
	const handleActivation = () => {
		if (examTargetYear !== undefined) {
			const membership = currentUser[`membership_${examTargetYear}`];
			if (membership?.isPaid ?? false) {
				endFreeTrial()
					.then(() => console.info('Ended free trial'))
					.catch((e) => console.error('Error loading exam', e));
			}
		}
	};

	handleActivation();
	return (
		<Alert
			title='Tu cuenta está en período de prueba...'
			type='info'
			classes='mb-8'>
			<p>
				<strong>Nota:</strong> La modalidad de tu cuenta es de prueba y está
				limitada a hacer simulaciones de un solo ENURM (2020). Debes completar
				tu pago para usar tener acceso al contenido premium y continuar usando
				nuestra plataforma sin interrumpciones.
			</p>
			<Link to={routes.CHECKOUT.CHECKOUT} className='btn bg-alt2-500'>
				Completar Pago
			</Link>
		</Alert>
	);
};
export default FreeTrialAlert;
